import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrashCan } from "@fortawesome/free-solid-svg-icons";

import Personnel_Details_Edit_Offcanvas from "../Personnel_Details_Edit_Offcanvas/Personnel_Details_Edit_Offcanvas";
import Personnel_Details_View_Offcanvas from "../Personnel_Details_View_Offcanvas/Personnel_Details_View_Offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import {
  GetAll,
  Delete,
} from "../../../../../../../features/admin/quality_management/resource_requirement/personal_detail/Slice";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../../../../../utils/common";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";

function Personnel_Details_table({ data, setCurrentPage, currentPage , fetchCustomers}) {
  const tableData = (data?.data || []).filter(Boolean);

  const [view, setView] = useState(false);
  const [viewId, setViewId] = useState(null);
  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);

  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

  const dispatch = useDispatch();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* ================= DELETE ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      fetchCustomers(currentPage); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(
    FixIDS.personnel_details.List,
  );
  const haveEditPermission = permissions?.includes(
    FixIDS.personnel_details.Edit,
  );

  const haveDeletePermission = permissions?.includes(
    FixIDS.personnel_details.Delete,
  );
  const haveViewPermission = permissions?.includes(
    FixIDS.personnel_details.View,
  );

  console.log(tableData, "tableData tableData");

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Experience</th>
                  <th>Qualification</th>
                  <th>Specialization</th>
                  <th>Relevant Training</th>
                  <th>Contact No.</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {tableData?.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No data found
                    </td>
                  </tr>
                ) : (
                  tableData?.map((row, index) => (
                    <tr key={row.id}>
                      {/* <td>{index+1}</td> */}
                      <td>
                        {(currentPage - 1) *
                          (data?.per_page || tableData.length) +
                          index +
                          1}
                      </td>
                      {/* <td>
                      {new Date(row?.createdAt).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td> */}
                      <td>{formatDate(row?.createdAt)}</td>
                      <td>{row.name}</td>
                      <td>{row.Designation?.name || "-"}</td>
                      <td>{row.experience} Years</td>
                      <td>{row.Qualification?.name || "-"}</td>
                      <td>{row.Specialization?.name || "-"}</td>
                      <td>{row.Relevant_Training?.name || "-"}</td>
                      <td>{row.contact_no}</td>
                      <td>{row.email}</td>
                      {/* Action */}
                      <td>
                        <div className="action_icons">
                          {haveViewPermission && (
                            <FontAwesomeIcon
                              icon={faEye}
                              onClick={() => {
                                setView(true);
                                setViewId(row.id);
                              }}
                            />
                          )}
                          {haveEditPermission && (
                            <FontAwesomeIcon
                              icon={faPen}
                              onClick={() => {
                                setEdit(true);
                                setEditId(row.id);
                              }}
                            />
                          )}
                          {haveDeletePermission && (
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              onClick={() => {
                                setSelectedDeleteId(row.id); // store ID
                                setDelete(true); // open offcanvas
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show_text">
              Showing {tableData.length} of {data?.total || 0} Entries
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={currentPage}
              totalPages={data?.total_pages || 1}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* VIEW */}
      {haveReadPermission && (
        <Personnel_Details_View_Offcanvas
          show={view}
          handleClose={() => setView(false)}
          id={viewId}
        />
      )}

      {/* Edit */}

      <Personnel_Details_Edit_Offcanvas
        show={showEdit}
        handleClose={() => setEdit(false)}
        id={showEditId}
      />

      {haveDeletePermission && (
        <Delete_offcanvas
          show={showDelete}
          handleClose={() => setDelete(false)}
          handleDelete={handleDelete}
          offcanvasHeading="Delete Personal Details"
          massageText={"Personal Details"}
        />
      )}
    </>
  );
}

export default Personnel_Details_table;
